import { DocumentTaskListItem } from '@modules/tasks/components/DocumentTaskListItem';
import { FormTaskListItem } from '@modules/tasks/components/FormTaskListItem';
import { AvatarGroup, Stack, useMediaQuery, useTheme } from '@mui/material';
import { ProjectTaskFragmentFragment } from 'gql/index';
import React, { useMemo } from 'react';
import { CustomTaskListItem } from './CustomTaskListItem';
import { UserAvatar } from '@components/UserAvatar/UserAvatar';

interface Props {
  task: ProjectTaskFragmentFragment;
  onOpenTask?: (task: ProjectTaskFragmentFragment, projectId: number) => void;
  secondaryAction?: React.ReactNode;
  showAssignees?: boolean;
}

const AssigneesAvatars: React.FC<{ assignees: { id: string; fullName?: string | null; }[]; }> = ({ assignees }) => {
  if (assignees.length === 0) return null;

  return (
    <AvatarGroup max={3} spacing='small' sx={{ '& .MuiAvatar-root': { width: 24, height: 24, fontSize: 12 } }}>
      {assignees.map(assignee => (
        <UserAvatar key={assignee.id} displayName={assignee.fullName ?? ''} />
      ))}
    </AvatarGroup>
  );
};

export const TaskListItem: React.FC<Props> = ({ task, onOpenTask, secondaryAction, showAssignees = true }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const assigneesAdornment = useMemo(() => {
    if (!showAssignees) return null;
    const uniqueAssignees = task.assignees ?? [];
    if (uniqueAssignees.length === 0) return null;

    return (
      <Stack direction='row' alignItems='center' spacing={1} flexShrink={0}>
        <AssigneesAvatars assignees={uniqueAssignees} />
      </Stack>
    );
  }, [isMobile, showAssignees, task.assignees]);



  if (task.projectForm) {
    return <FormTaskListItem task={task} form={task.projectForm} onOpenTask={onOpenTask} secondaryAction={secondaryAction} assigneesAdornment={assigneesAdornment} />;
  } else if (task.document) {
    return <DocumentTaskListItem task={task} document={task.document} onOpenTask={onOpenTask} secondaryAction={secondaryAction} assigneesAdornment={assigneesAdornment} />;
  } else {
    return <CustomTaskListItem task={task} onOpenTask={onOpenTask} secondaryAction={secondaryAction} assigneesAdornment={assigneesAdornment} />;
  }
};